import React from 'react';
import './App.css';

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-block">
                <div className="category"> Use the icon library </div>
                <div className="description"> 
                    <a href="https://www.npmjs.com/package/hash-heroes">
                        https://www.npmjs.com/package/hash-heroes
                    </a> 
                </div>
            </div>

            <div className="footer-block">
                <div className="category"> Donate </div>
                <div className="description"> 0xB0623C91c65621df716aB8aFE5f66656B21A9108 </div>
            </div>

            <div className="footer-block">
                <div className="category"> Contact </div>
                <div className="description">
                    <a href="mailto:hashheroes@gmail.com">
                        khakisoftwareprojects@gmail.com
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js